import React, { memo } from 'react';
import dynamic from 'next/dynamic';
import Cookies from '@repo/ui/src/components/Cookies/Cookies';
import { useIsDesktop } from '@repo/ui/src/providers/DeviceProvider';
import { useNavigation } from '@repo/ui/src/providers/NavigationProvider';

const Cursor = dynamic(() => import('@repo/ui/src/components/Cursor/Cursor'), { ssr: false });
const Menu = dynamic(() => import('@/components/Menu', { ssr: false }));
const Footer = dynamic(() => import('@/components/Footer/Footer', { ssr: false }));

const Layout = ({ cookies, children, menu, footer }) => {
	const isDesktop = useIsDesktop(true);
	const isHtmlLoaded = useNavigation((state) => state.isHtmlLoaded);

	return (
		<>
			{isDesktop && isHtmlLoaded && <Cursor />}
			<Menu menu={menu} />
			<Cookies data={cookies} />
			{children}
			<Footer data={footer} />
		</>
	);
};
export default memo(Layout);
